import { storage } from 'lib/storage';
import { Record } from 'immutable';

export const ROLES = {
  accountant: 'accountant',
  'limited-accountant': 'limited-accountant',
  'restricted-accountant': 'restricted-accountant',
  user: 'user',
  'restricted-user': 'restricted-user',
  'confidential-user': 'confidential-user',
  'confidential-restricted-user': 'confidential-restricted-user',
  supplier: 'supplier',
};

export function checkRoles(role) {
  if (role && typeof ROLES[role] !== 'undefined') return role;
  return null;
}

export function getRoles() {
  const role = storage().role().get();
  return checkRoles(role);
}

export function setRoles(role) {
  const r = checkRoles(role);
  if (r !== null && r !== undefined) return storage().role().set(r);
  return false;
}

export function userAdapter({ userId, chatUser, chatToken, role, userGUID }) {
  const userFactory = new Record({
    userId: null,
    chatUser: null,
    chatToken: null,
    role: null,
    userGUID: null,
  });
  return userFactory({
    userId,
    chatUser,
    chatToken,
    role,
    userGUID,
  });
}

export const Apps = {
  AP: 'AP',
  PAY: 'PAY',
  MC: 'MC',
};
